import React, { useState,  forwardRef, useContext, useEffect, useRef } from 'react';
import axios from 'axios';
import { AuthorizeContext } from "../../RootContext";
import { Link, useParams } from 'react-router-dom';
import { api_url } from "../../authorize";
import { createMuiTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';
import logo from './../../img/lento_logo_transparent.png';
import moment from 'moment';

import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import MaterialTable from 'material-table';
import Button from '@material-ui/core/Button';
import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import FlagIcon from '@material-ui/icons/Flag';


const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} fontSize="large"/>),
    SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
    Flag: forwardRef((props, ref) => <FlagIcon {...props} ref={ref} />),
  };

  const useStyles = makeStyles((theme) => ({
    page: {
      minHeight: 'calc(100vh - 72px)',
      padding: '28px 20px 44px',
      boxSizing: 'border-box',
      background: '#f3f7f9',
      color: '#173247',
      fontFamily: 'Segoe UI, Tahoma, Arial, sans-serif',

      [theme.breakpoints.down('sm')]: {
        padding: '20px 16px 32px',
      },
    },
    shell: {
      width: '100%',
      maxWidth: 'none',
      margin: 0,
    },
    pageHeader: {
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      gap: 20,
      marginBottom: 20,

      [theme.breakpoints.down('sm')]: {
        alignItems: 'flex-start',
        flexDirection: 'column',
      },
    },
    titleBlock: {
      minWidth: 0,
    },
    eyebrow: {
      margin: 0,
      color: '#0b819d',
      fontSize: 12,
      fontWeight: 800,
      letterSpacing: '0.10em',
      textTransform: 'uppercase',
    },
    pageTitle: {
      margin: '5px 0 0',
      color: '#173247',
      fontSize: 32,
      lineHeight: 1.15,
      fontWeight: 800,
      letterSpacing: '-0.025em',

      [theme.breakpoints.down('xs')]: {
        fontSize: 27,
      },
    },
    pageSubtitle: {
      margin: '8px 0 0',
      color: '#607888',
      fontSize: 16,
      lineHeight: 1.55,
      fontWeight: 500,
    },
    countBadge: {
      flex: '0 0 auto',
      padding: 0,
      border: 'none',
      background: 'transparent',
      color: '#607888',
      fontSize: 16,
      fontWeight: 700,
      lineHeight: 1.4,
      whiteSpace: 'nowrap',
    },
    toolbar: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: 12,
      marginBottom: 16,
    },
    primaryButton: {
      minHeight: 44,
      padding: '0 18px',
      borderRadius: 10,
      background: 'linear-gradient(135deg, #109bb9 0%, #08728c 100%)',
      color: '#ffffff',
      fontSize: 15,
      fontWeight: 800,
      textTransform: 'none',
      boxShadow: '0 8px 18px rgba(8, 114, 140, 0.20)',

      '&:hover': {
        background: 'linear-gradient(135deg, #0d8eaa 0%, #065f75 100%)',
        boxShadow: '0 9px 20px rgba(8, 114, 140, 0.24)',
      },
    },
    secondaryButton: {
      minHeight: 44,
      padding: '0 18px',
      borderRadius: 10,
      border: '1px solid #cfdde3',
      background: '#ffffff',
      color: '#244154',
      fontSize: 15,
      fontWeight: 800,
      textTransform: 'none',
      boxShadow: 'none',

      '&:hover': {
        background: '#f5fafb',
        borderColor: '#9dcbd6',
      },
    },
    tableCard: {
      width: '100%',
      overflow: 'hidden',
      borderRadius: 16,
      border: '1px solid #dce7ec',
      background: '#ffffff',
      boxShadow: '0 16px 36px rgba(13, 46, 67, 0.08)',

      // Fit all 17 admin columns inside the available table width.
      // Styling only: no table data, API, filtering, or workflow logic changed.
      '& .MuiTableContainer-root': {
        width: '100% !important',
        maxWidth: '100% !important',
        overflowX: 'hidden !important',
      },

      '& .MuiTable-root': {
        fontFamily: 'Segoe UI, Tahoma, Arial, sans-serif !important',
        width: '100% !important',
        maxWidth: '100% !important',
        minWidth: '0 !important',
        tableLayout: 'fixed !important',
      },

      '& .MuiTable-root colgroup': {
        display: 'none !important',
      },

      '& .MuiTableCell-root': {
        fontFamily: 'Segoe UI, Tahoma, Arial, sans-serif !important',
        boxSizing: 'border-box !important',
        minWidth: '0 !important',
        paddingLeft: '4px !important',
        paddingRight: '4px !important',
        overflow: 'hidden !important',
      },

      '& .MuiTableCell-head': {
        fontSize: '13px !important',
        fontWeight: '700 !important',
        lineHeight: '1.15 !important',
        paddingTop: '10px !important',
        paddingBottom: '10px !important',
        whiteSpace: 'normal !important',
        overflowWrap: 'normal !important',
        wordBreak: 'normal !important',
      },

      '& .MuiTableCell-body': {
        fontSize: '14px !important',
        fontWeight: '600 !important',
        lineHeight: '1.25 !important',
        paddingTop: '10px !important',
        paddingBottom: '10px !important',
        whiteSpace: 'normal !important',
        overflowWrap: 'anywhere !important',
      },

      '& .MuiTableCell-root:nth-child(1)': { width: '6% !important' },
      '& .MuiTableCell-root:nth-child(2)': { width: '6% !important' },
      '& .MuiTableCell-root:nth-child(3)': { width: '8% !important' },
      '& .MuiTableCell-root:nth-child(4)': { width: '6% !important' },
      '& .MuiTableCell-root:nth-child(5)': { width: '6% !important' },
      '& .MuiTableCell-root:nth-child(6)': { width: '6% !important' },
      '& .MuiTableCell-root:nth-child(7)': { width: '6% !important' },
      '& .MuiTableCell-root:nth-child(8)': { width: '6% !important' },
      '& .MuiTableCell-root:nth-child(9)': { width: '5% !important' },
      '& .MuiTableCell-root:nth-child(10)': { width: '4% !important' },
      '& .MuiTableCell-root:nth-child(11)': { width: '6% !important' },
      '& .MuiTableCell-root:nth-child(12)': { width: '5% !important' },
      '& .MuiTableCell-root:nth-child(13)': { width: '5% !important' },
      '& .MuiTableCell-root:nth-child(14)': { width: '6% !important' },
      '& .MuiTableCell-root:nth-child(15)': { width: '8% !important' },
      '& .MuiTableCell-root:nth-child(16)': { width: '5.5% !important' },
      '& .MuiTableCell-root:nth-child(17)': { width: '5.5% !important' },

      // Keep Assigned To compact so it cannot force the table wider.
      '& .MuiTableCell-head:nth-child(15)': {
        whiteSpace: 'normal !important',
      },

      '& .MuiTableCell-body:nth-child(15)': {
        fontSize: '12.5px !important',
        fontWeight: '600 !important',
        whiteSpace: 'nowrap !important',
        overflow: 'hidden !important',
        textOverflow: 'ellipsis !important',
      },

      '& .MuiTableCell-body:nth-child(15) > *': {
        maxWidth: '100%',
        display: 'block',
        whiteSpace: 'nowrap !important',
        overflow: 'hidden !important',
        textOverflow: 'ellipsis !important',
      },
    },
    loadingScreen: {
      position: 'fixed',
      top: 72,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 1200,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      background: '#ffffff',
    },

    loadingLogoWrap: {
      width: 'min(680px, 62vw)',
      maxWidth: 'calc(100vw - 48px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      [theme.breakpoints.down('sm')]: {
        width: 'min(520px, 78vw)',
      },

      [theme.breakpoints.down('xs')]: {
        width: 'min(390px, 86vw)',
      },
    },

    loadingLogo: {
      display: 'block',
      width: '100%',
      height: 'auto',
      objectFit: 'contain',
      background: 'transparent',
      filter: 'none',
    },
  }));

  const tableStyles = makeStyles({
    root: {justifyContent: 'space-evenly'},
    spacing: {justifyContent: 'space-evenly'}
  });

  const theme = createMuiTheme({
    typography: {
      fontFamily: 'Segoe UI, Tahoma, Arial, sans-serif',
      h6: {
        fontSize: '1.35rem',
        fontWeight: 800,
      },
      body1: {
        fontSize: '1rem',
      },
      body2: {
        fontSize: '0.95rem',
      },
    },
    overrides: {
      MuiTableCell: {
        root: {
          padding: '14px 7px',
          fontSize: '17px',
          lineHeight: 1.35,
          borderBottom: '1px solid #edf1f3',
          color: '#244154',
          whiteSpace: 'normal',
          overflowWrap: 'anywhere',
        },
        head: {
          padding: '14px 7px',
          backgroundColor: '#f1f6f8',
          color: '#173247',
          fontSize: '16px',
          lineHeight: 1.2,
          fontWeight: 800,
          whiteSpace: 'normal',
          overflowWrap: 'normal',
          wordBreak: 'normal',
          borderBottom: '1px solid #dce7ec',
        },
      },
      MuiInputBase: {
        root: {
          fontSize: '16px',
        },
      },
      MuiInput: {
        underline: {
          '&:before': {
            borderBottomColor: '#c8d7dd',
          },
          '&:after': {
            borderBottomColor: '#109bb9',
          },
        },
      },
      MuiTablePagination: {
        root: {
          fontSize: '16px',
          color: '#244154',
        },
        caption: {
          fontSize: '16px',
        },
        select: {
          fontSize: '16px',
        },
      },
      MuiToolbar: {
        root: {
          minHeight: '68px',
        },
      },
      MuiIconButton: {
        root: {
          color: '#3f5f70',
        },
      },
    },
  });


const MRIqcList = () => {
  const classes = useStyles();
  const tableClass = tableStyles();
  const { token, role, user, authBody, setAuthBody, setAuthenticated } = useContext(AuthorizeContext);
  const [data, setData] = useState({})
  const [columnFilters, setColumnFilters ]= useState({});
  let temp = [];
  const [loading, setLoading] = useState(true);
  let { surgeonid } = useParams();
  const [profile, setProfile] = useState(authBody || {role: "visitor"});
  const hasRole = (profile, roles) =>{
    return roles.includes(role);
  };

  let tableRef = useRef(MaterialTable);

const clearFilter = () => {
        
    localStorage.removeItem('columnFilters');
   window.location.reload();
    }

const SaveFilterData = (thing) =>{
  console.log(tableRef.current.state)
  if (tableRef.current.dataManager.filteredData <1){
    localStorage.removeItem('columnFilters');
    localStorage.setItem('columnFilters',JSON.stringify(tableRef.current.state.originalData));
    // useEffect();
    //alert("Filter has returned no Results.\n\n Refreshing to Full Data SET")

   // window.location.reload();
  }
  else{
    localStorage.setItem('columnFilters',JSON.stringify(tableRef.current.dataManager.filteredData));
  }
}
  console.log(data)
  useEffect(() => {
      let savedFilters = JSON.parse(localStorage.getItem('columnFilters'));
      console.log(savedFilters)
      if (savedFilters || JSON.stringify(savedFilters) > 5) {

        setColumnFilters(savedFilters);
      console.log("Saved Filters are here -->");
      }
      else{ savedFilters= 0}

    ////////////////////////
    const fetchData = async () => {
      if (role.includes("admin") && savedFilters){
        setLoading(false)
        setState((prevState) => ({
          ...prevState, data: savedFilters
        }));
      }
      else if (role.includes("admin") && !savedFilters){
        const admin = await axios({
          url: `https://${api_url}/api/case_list?status=active&spec=MQC`,
          method: 'get',
          headers: {
            'x-access-token' : token
          }
        })

        setLoading(false)
        setState((prevState) => ({
          ...prevState, data: admin.data
        }))

      }
      else if(role.includes("hospital")){
        const hos = await axios({
          url: `https://${api_url}/api/hospital_list?for_hospital=true&status=active`,
          method: 'get',
          headers: {
            'x-access-token' : token
          }
        })

          console.log(hos)
          setLoading(false)

          setState((prevState) => ({
            ...prevState, data: hos.data.active
          })) 
      }

      else if(role.includes("distributor")){
        const dis = await axios({
          url: `https://${api_url}/api/distributor_list?for_distributor=true&status=active`,
          method: 'get',
          headers: {
            'x-access-token' : token
          }
        })

        console.log(dis)
        setLoading(false)

        setState((prevState) => ({
          ...prevState, data: dis.data
        }))
      }
      else{
          const res = await axios({
            url: `https://${api_url}/api/case_list?${role}=${user.Email_Address}&surgeon=${surgeonid}&status=active`,
            method: 'get',
            headers: {
              'x-access-token' : token
            }
          })
        setLoading(false)

        setState((prevState) => ({
          ...prevState, data: res.data
        }))
      }
    }
    fetchData()

  }, [setState]);

  let lookup = hasRole(profile, ['super_admin', 'write_admin', 'read_admin']) ?
    {
      1: "New Order",
      2: 'MRI',
      3: 'MRI QC',
      4: 'Planning 1',
      5: 'Planning 2',
      6: 'Surgeon Approval',
      7: 'Template Design',
      8: 'G Code',
      9: 'CNC',
      10: 'Final QC',
      11: 'Shipped'
    } :

    {
      1: hasRole(profile, ['mri_center']) ? 'Ready to Upload MRI' : 'Waiting for MRI',
      2: 'In Progress',
      'MRI':'In Progress',
      3: 'In Progress',
      "MRI_QC": 'In Progress',
      4: 'In Progress',
      'Planning_1':'In Progress',
      5: hasRole(profile, ['distributor', 'surgeon']) ? 'Surgeon Approval Ready' : 'Approval Ready',
      'Planning_2': 'Approval Ready',
      6: 'Surgeon Approved',
      'Surgeon_approval': 'Surgeon Approved',
      7: 'Surgeon Approved',
      'Template_design': 'Manufacturing',
      8: 'Surgeon Approved',
      'G_code': 'Manufacturing',
      9: 'Surgeon Approved',
      'CNC': 'Manufacturing',
      10: 'Surgeon Approved',
      'Final_QC': 'Manufacturing',
      11: 'Shipped',
      'Shipped': 'Shipped'
    }


  const handleClose = () => {
    setState({...state, dialogFlagOpen: false});
  };

  const handleSlotClose = () => {
    setState({...state, dialogMessageOpen: false});

  }
  console.log(state)
  const handleSubmit = () => {
    axios({
      url: `https://${api_url}/api/case?case_id=${state.rowData.case_id}&update=remove_flag`,
      method: 'put',
      headers: {
        'x-access-token' : token
      }
    }).then(
      res => {
        if(res.data.message){
          alert(res.data.message)
          setState({...state, dialogFlagOpen: false})
        }
        else if(res.data.notLoggedIn){
          setAuthenticated(false)
          setAuthBody({role: 'visitor'})
          alert("You have been logged out due to inactivity. Please log in again.")
        }
        else{
        setState({...state, dialogFlagOpen: false})
        window.location.reload()
        }

      }
    );
  }

  const handleAssign = () => {
    axios({
      url: `https://${api_url}/api/assign_command`,
      method: 'post',
      headers: {
        'x-access-token' : token
      }
    }).then(
      res => {
        if(res.data.message){
          alert(res.data.message)
          setState({...state, dialogFlagOpen: false})
        }
        else if(res.data.notLoggedIn){
          setAuthenticated(false)
          setAuthBody({role: 'visitor'})
          alert("You have been logged out due to inactivity. Please log in again.")
        }
        else{
        setState({...state, dialogFlagOpen: false})
        window.location.reload()
        }

      }
    );
  }



  const [state, setState] = useState({
    adminColumns: [
      { title: 'Case #', field:'case_id',  editable: "never", filtering: false, render:rowData => {
          return (
            <div>
            <Link type="text" to={`/case/${rowData.case_id}`}>{rowData.case_id}</Link>
            </div>
          )},
          cellStyle: {
            fontSize: '17px', fontWeight: 600
          }, defaultSort: 'asc'
      },
      { title: 'Partner', field: 'site', filtering: 'false',
        emptyValue: "",
        cellStyle: {
          fontSize: '17px', fontWeight: 600
        }
      },
      { title: 'Surgeon Name', field:'Surgeon.Last_Name', editable: "never", filterting: false, render: rowData => {
        return(
          <div>
            {rowData.Surgeon.Last_Name}, {rowData.Surgeon.First_Name} {rowData.Surgeon.Middle_Name}
          </div>
        )},
        cellStyle: {
          fontSize: '17px', fontWeight: 600
        }
      },
      { title: 'Patient Last Name', field:'Patient.Last_Name', filtering: false,
        cellStyle: {
          fontSize: '17px', fontWeight: 600
        }
      },
      { title: 'Patient First Name', field:'Patient.First_Name', filtering: false,
        cellStyle: {
          fontSize: '17px', fontWeight: 600
        }
      },
      // { title: 'Patient Sex', field:'Patient.Sex', filtering: false,
      //   lookup: {
      //     'male': 'male',
      //     'female': 'female'
      //   },
      //   cellStyle: {
      //     fontSize: '17px', fontWeight: 600
      //   }
      // },
      { title: 'DOPO', field:'dateCreated', editable: "never", filtering: 'false', type:'date',
        cellStyle:{
          fontSize: '17px', fontWeight: 600
        },
          customSort: (a , b) => {
            a = moment(a.dateCreated).format();
            b = moment(b.dateCreated).format();
            return b > a ? 1 : -1;
          }
      },
      { title: 'DOS', field:'Patient.Date_of_Surgery', filtering: 'false', type: 'date',
        cellStyle: {
          fontSize: '17px', fontWeight: 600
        },
          customSort: (a , b) => {
            a = moment(a.Patient.Date_of_Surgery).format();
            b = moment(b.Patient.Date_of_Surgery).format();
            return b > a ? 1 : -1;
          }
      },
      { title: 'Surgery Type', field:'Patient.Surgery_Type', editable: "never", filtering: 'false',
        cellStyle: {
          fontSize: '17px', fontWeight: 600
        }
      },
      {
        title: 'Expedite', field: 'expedite', type: 'boolean'
      },
      { title: 'Status', field:'case_status', filtering: true, 
        lookup: lookup,
        // emptyValue: "New Order",
        cellStyle:
          rowData =>
          {
            // console.log(rowData)
            return(rowData !== 13 ?
                      ({background: '#eaf7fa',
                        backgroundColor: '#eaf7fa',
                        color: '#0b7189',
                        textAlign: 'center',
                        fontSize: '17px', fontWeight: 400})

                        :
                      ({
                        backgroundColor: "#990000",
                        backgroundImage: "linear-gradient(to right, #bdc3c7, #2c3e50)",
                        color: 'white',
                        textAlign: 'center',
                        fontSize: '17px', fontWeight: 600
                      }))
          }

      },
      {
        title: 'Site', field: 'geo', filtering: 'false',
        lookup: {
                  "EU": 'Houston',
                  "US": 'Dallas',
                  "KR": 'Korea',
            },
        emptyValue: "EU",
      },
      {
        title: 'Flag', field: 'flag_status', filtering: 'false', editable: 'never', type:"text", cellStyle:
        rowData =>
          {
            return(rowData.includes("no_flag") ?
              null

              :
              ({
                  background: '#fff0ef',
                  backgroundColor: '#fff0ef',
                  color: '#a23b34',
                  textAlign: 'center',
                  fontSize: '17px', fontWeight: 600
              }))
          }
      },
      {
        title: 'Expert Flag', field:'expert_flag', type: 'boolean', editable: 'never'
      },
      {
        title: 'Assigned To',
        field:'assigned',
        editable: 'never',
        cellStyle: {
          fontSize: '14px',
          fontWeight: 600,
          whiteSpace: 'nowrap',
          wordBreak: 'normal',
          overflowWrap: 'normal'
        },
        render: rowData => (
          <span style={{ whiteSpace: 'nowrap' }}>
            {rowData.assigned || '-'}
          </span>
        )
      },
      {
        title: 'Femur Slot', field: 'femur_slot', filtering: 'false', type: "boolean", emptyValue: <Check />,
        cellStyle: {
          textAlign: 'center',
          fontSize: '17px',
          fontWeight: 600
        }
      },
      {
        title: 'Tibia Slot', field: 'tibia_slot', filtering: 'false', type: "boolean", emptyValue: <Check />,
        cellStyle: {
          textAlign: 'center',
          fontSize: '17px',
          fontWeight: 600
        }
      }
    ],

    columns: [
      { title: 'Case #', field:'case_id',  editable: "never", filtering: false, render:rowData => {
          return (
            <div>
            <Link type="text" to={`/case/${rowData.case_id}`}>{rowData.case_id}</Link>
            </div>
          )},
          cellStyle: {
            fontSize: '17px', fontWeight: 600
          }, defaultSort: hasRole(profile, ['distributor']) ? 'asc' : null
      },
      // { title: 'PO #', field:'po_number', filterting: false, editable: (row, rowData) => {
      //     return rowData && !
      //     rowData.po_number
      //   },
      //   cellStyle: {
      //     fontSize: '17px', fontWeight: 600
      //   }
      // },
      { title: 'Surgeon Name', field:'Surgeon.Last_Name', editable: "never", filterting: false, render: rowData => {
        return(
          <div>
            {rowData.Surgeon.Last_Name}, {rowData.Surgeon.First_Name} {rowData.Surgeon.Middle_Name}
          </div>
        )},
        cellStyle: {
          fontSize: '17px', fontWeight: 600
        }
      },

      { title: 'Patient Name', field:'Patient.Last_Name', editable: "never", filtering: false, render: rowData => {
        return(
          <div>
            {rowData.Patient.Last_Name}, {rowData.Patient.First_Name}
          </div>
        )},
        cellStyle: {
          fontSize: '17px', fontWeight: 600
        }
      },
      { title: 'DOPO', field:'dateCreated', editable: "never", filtering: 'false', type:'date',
        cellStyle:{
          fontSize: '17px', fontWeight: 600
        },
          customSort: (a , b) => {
            a = moment(a.dateCreated).format();
            b = moment(b.dateCreated).format();
            return b > a ? 1 : -1;
          }
      },      
      { title: 'DOS', field:'Patient.Date_of_Surgery', editable: "never", filtering: 'false', type: 'date',
        cellStyle: {
          fontSize: '17px', fontWeight: 600
        }, defaultSort: hasRole(profile, ['surgeon']) ? 'asc' : null,
          customSort: (a , b) => {
            a = moment(a.Patient.Date_of_Surgery).format();
            b = moment(b.Patient.Date_of_Surgery).format();
            return b > a ? 1 : -1;
          }
      },
      { title: 'Surgery Type', field:'Patient.Surgery_Type', editable: "never", filtering: 'false',
        cellStyle: {
          fontSize: '17px', fontWeight: 600
        }
      },
      { title: 'Surgery Side', field:'Patient.Side_of_Body', editable: "never", filtering: 'false',
        cellStyle: {
          fontSize: '17px', fontWeight: 600
        }
      },
      { title: 'Status', field:'case_status', filtering: 'false',
        editable: 'never',
        lookup: lookup,
        emptyValue: "New Order",
        cellStyle: {
          background: 'linear-gradient(315deg, #045de9 0%, #09c6f9 74%)',
          backgroundColor: "#045de9",
          color: 'white',
          textAlign: 'center',
          fontSize: '17px', fontWeight: 600
        }
      }
    ],
    hosColumns: [
      { title: 'Case #', field:'case_id',  editable: "never", filtering: false, render:rowData => {
          return (
            <div>
            <Link type="text" to={`/case/${rowData.case_id}`}>{rowData.case_id}</Link>
            </div>
          )},
          cellStyle: {
            fontSize: '17px', fontWeight: 600
          }, defaultSort: hasRole(profile, ['distributor']) ? 'asc' : null
      },
      { title: 'Surgeon Name', field:'Surgeon.Last_Name', editable: "never", filterting: false, render: rowData => {
        return(
          <div>
            {rowData.Surgeon.Last_Name}, {rowData.Surgeon.First_Name} {rowData.Surgeon.Middle_Name}
          </div>
        )},
        cellStyle: {
          fontSize: '17px', fontWeight: 600
        }
      },
      { title: 'Patient Name', field:'Patient.Last_Name', editable: "never", filtering: false, render: rowData => {
        return(
          <div>
            {rowData.Patient.Last_Name}, {rowData.Patient.First_Name}
          </div>
        )},
        cellStyle: {
          fontSize: '17px', fontWeight: 600
        }
      },
      { title: 'DOPO', field:'dateCreated', editable: "never", filtering: 'false', type:'date',
        cellStyle:{
          fontSize: '17px', fontWeight: 600
        },
          customSort: (a , b) => {
            a = moment(a.dateCreated).format();
            b = moment(b.dateCreated).format();
            return b > a ? 1 : -1;
          }
      },
      { title: 'DOS', field:'Patient.Date_of_Surgery', editable: "never", filtering: 'false', type: 'date',
        cellStyle: {
          fontSize: '17px', fontWeight: 600
        }, defaultSort: hasRole(profile, ['surgeon']) ? 'asc' : null,
          customSort: (a , b) => {
            a = moment(a.Patient.Date_of_Surgery).format();
            b = moment(b.Patient.Date_of_Surgery).format();
            return b > a ? 1 : -1;
          }
      },
      { title: 'Surgery Type', field:'Patient.Surgery_Type', editable: "never", filtering: 'false',
        cellStyle: {
          fontSize: '17px', fontWeight: 600
        }
      },
      { title: 'Surgery Side', field:'Patient.Side_of_Body', editable: "never", filtering: 'false',
        cellStyle: {
          fontSize: '17px', fontWeight: 600
        }
      }
    ]
  });

    console.log(state)

  if(state.data){
    console.log(state.data)
    if(state.data.notLoggedIn){

      setAuthenticated(false);
      setAuthBody({role: 'visitor'});
      alert("You have been logged out due to inactivity. Please log in again.");
      localStorage.removeItem("columnFilters");
    }
  }

  else if (loading) {
    return (
      <div className={classes.loadingScreen}>
        <div className={classes.loadingLogoWrap}>
          <img
            className={classes.loadingLogo}
            src={logo}
            alt="Lento Medical Innovation"
          />
        </div>
      </div>
    );
  }

  const visibleCaseCount = Array.isArray(state.data) ? state.data.length : 0;

  return(
    <div className={classes.page}>
      <div className={classes.shell}>
        <ThemeProvider theme={theme}>
          <div className={classes.pageHeader}>
            <div className={classes.titleBlock}>
              <p className={classes.eyebrow}>Process stage</p>
              <h1 className={classes.pageTitle}>
                {hasRole(profile, ['hospital']) ? 'Surgery List' : 'QC'}
              </h1>

            </div>
            <div className={classes.countBadge}>
              {visibleCaseCount} {visibleCaseCount === 1 ? 'case' : 'cases'}
            </div>
          </div>

          <div className={classes.toolbar}>
            {hasRole(profile, ['super_admin', 'write_admin']) ? (
              <Button
                className={classes.primaryButton}
                onClick={handleAssign}
                variant="contained"
                disableElevation
              >
                Assign
              </Button>
            ) : null}

            {hasRole(profile, ['super_admin', 'write_admin','read_admin']) ? (
              <Button
                className={classes.secondaryButton}
                onClick={clearFilter}
                variant="outlined"
              >
                Clear Search Filters
              </Button>
            ) : null}
          </div>

          <div className={classes.tableCard}>
    <MaterialTable
      tableRef={tableRef}
      title={hasRole(profile, ['hospital']) ? "Surgery List" : "Active List"}
      columns={hasRole(profile, ['super_admin', 'write_admin', 'read_admin']) ? state.adminColumns :
        hasRole(profile, ['hospital']) ?
        state.hosColumns
        :
        state.columns
      }
      data={state.data}
      icons={tableIcons}
      // onSearchChange={handleSearchChange}
      onSearchChange={(e) => console.log("search changed: " + e)}
      // onFilterChange={(e) => console.log("filter changed: " + e.current)}
      onFilterChange={SaveFilterData}
      onQueryChange={(e) => console.log("table changed: " + e)}
      actions={
        hasRole(profile, ['super_admin', 'write_admin']) ? 
        [{
          icon: tableIcons.Flag,
          tooltip: 'Reset Flag',
          onClick: (event, rowData) => {
            setState({...state, dialogFlagOpen: true, rowData})
        }
        }
        ]
        :
        null
      }

      editable={
        hasRole(profile, ['super_admin', 'write_admin', 'distributor']) ?
        {
        isEditable:rowData=> hasRole(profile, ['distributor']) ? !rowData.po_number
        : rowData
        ,
        onRowUpdate: (newData, oldData) =>
           new Promise((resolve, reject) => {
             setTimeout(() => {
               {
                 {/*const data = [...data.data];
                 const index = data.indexOf(oldData);
                 data[index] = newData;*/}
                 const data = [...state.data];
                 const index = data.indexOf(oldData);
                 data[index] = newData;

                console.log(newData)
                if(oldData.femur_slot != newData.femur_slot ){
                 if((newData.femur_slot == true) || (newData.femur_slot == false)){
                     axios({
                       url: `https://${api_url}/api/case?case_id=${newData.case_id}&update=slotSkip&femur=${newData.femur_slot == true ? 1 : 0}`,
                       method: 'put',
                       headers: {
                         'x-access-token' : token
                       }
                     }).then(res=> {
                       if(res.data.message){
                         setState({...state, dialogMessageOpen: true, oldData, error: res.data.message})
                       }
                       else if(res.data.notLoggedIn){
                         setAuthenticated(false)
                         setAuthBody({role: 'visitor'})
                         alert("You have been logged out due to inactivity. Please log in again.")
                       }
                       else{
                         console.log(data[index].femur_slot)
                         setState({...state, data})
                         alert("Femur Slot has successfully changed.\nReminder: You can change only one slot at a time.")
                       }

                     })
                   }
                 }
                 else if(oldData.tibia_slot != newData.tibia_slot){
                   axios({
                     url: `https://${api_url}/api/case?case_id=${newData.case_id}&update=slotSkip&tibia=${newData.tibia_slot == true ? 1 : 0}`,
                     method: 'put',
                     headers: {
                       'x-access-token' : token
                     }
                   }).then(res=> {
                     if(res.data.message){
                       setState({...state, dialogMessageOpen: true, oldData, error: res.data.message})
                     }
                     else if(res.data.notLoggedIn){
                       setAuthenticated(false)
                       setAuthBody({role: 'visitor'})
                       alert("You have been logged out due to inactivity. Please log in again.")
                     }
                     else{
                       setState({...state, data})
                       alert("Tibia Slot has successfully changed.\nReminder: You can change only one slot at a time.")

                     }

                   })
                 }
                 else if (oldData.expedite != newData.expedite){
                   console.log("hi")
                   axios({
                     url: `https://${api_url}/api/case?case_id=${oldData.case_id}&update=expedite&expedite=0`,
                     method: 'put',
                     headers: {
                       'x-access-token' : token
                     }
                   }).then(res=> {
                     if(res.data.message){
                       setState({...state, dialogMessageOpen: true, newData, error: res.data.message})
                       window.location.reload()
                     }
                     else if(res.data.notLoggedIn){
                       setAuthenticated(false)
                       setAuthBody({role: 'visitor'})
                       alert("You have been logged out due to inactivity. Please log in again.")
                     }
                     else{
                        setState({...state, data})
                        alert(`Case ${oldData.case_id} has been unassigned and expedite status has been removed. To expedite and assign an expert, go to the case details page `)
                        window.location.reload()
                     }
                   })
                 }
               else if (oldData.geo != newData.geo){
                 axios({
                   url: `https://${api_url}/api/case?case_id=${oldData.case_id}&update=geo&geo=${newData.geo}`,
                   method: 'put',
                   headers: {
                     'x-access-token' : token
                   },
                   data: newData
                 }).then(res=> {
                   if(res.data.message){
                     setState({...state, dialogMessageOpen: true, newData, error: res.data.message})
                     // window.location.reload()
                   }
                   else if(res.data.notLoggedIn){
                     setAuthenticated(false)
                     setAuthBody({role: 'visitor'})
                     alert("You have been logged out due to inactivity. Please log in again.")
                   }
                   else{
                      setState({...state, data})
                      alert(`Case ${oldData.case_id} geo has been changed.`)
                      window.location.reload()
                   }
                 })
               }
               else if (oldData.po_number !== newData.po_number){
                 axios({
                   url: `https://${api_url}/api/case?case_id=${oldData.case_id}&update=new_po`,
                   method: 'put',
                   headers: {
                     'x-access-token' : token
                   },
                   data: newData
                 }).then(res=> {
                   if(res.data.message){
                     setState({...state, dialogMessageOpen: true, newData, error: res.data.message})
                     window.location.reload()
                   }
                   else if(res.data.notLoggedIn){
                     setAuthenticated(false)
                     setAuthBody({role: 'visitor'})
                     alert("You have been logged out due to inactivity. Please log in again.")
                   }
                   else{
                      setState({...state, data})
                      alert("PO Number has been issued successfully")
                      window.location.reload()


                   }
                 })
               }
                 else if (newData.case_status > oldData.case_status || newData.case_status == 1){
                   reject(new Error(newData))
                   alert("Error: Status will not change. Please choose statuses previous to the current status.")

                 }
                 else if (oldData.case_status == 11 && !oldData.postpone){
                   reject(new Error(newData))
                   alert("Error: Status will not change. Order has already been shipped.")
                 }
                 else if(oldData.case_status == newData.case_status){
                   if(oldData == newData){
                     reject(new Error(newData))
                     alert("Error: Status will not change. Status already in progress.")
                   }
                   else{
                    axios({
                      url: `https://${api_url}/api/case?case_id=${newData.case_id}&update=edit_patient`,
                      method: 'put',
                      headers: {
                        'x-access-token' : token
                      },
                      data: newData

                    }).then(res=> {
                      if(res.data.message){
                        console.log(newData)
                        setState({...state, dialogMessageOpen: true, newData, error: res.data.message})
                      }
                      else if(res.data.notLoggedIn){
                        setAuthenticated(false)
                        setAuthBody({role: 'visitor'})
                        alert("You have been logged out due to inactivity. Please log in again.")
                      }
                      else{
                        alert(`Case ${oldData.case_id} patient data has been successfully updated.`)
                        window.location.reload()
                      }
                    })


                 }
               }
                 else if (oldData.case_status !== newData.case_status){
                   setState({ ...state, data });
                   console.log(newData)
                   console.log(data)
                   console.log(state)
                   axios({
                     url: `https://${api_url}/api/case?case_id=${newData.case_id}&update=change_case_status&change_status=${newData.case_status}`,
                     method: 'put',
                     headers: {
                       'x-access-token' : token
                     }
                   }).then(res=> {
                     if(res.data.message){
                       setState({...state, dialogMessageOpen: true, newData, error: res.data.message})
                       window.location.reload()
                     }
                     else if(res.data.notLoggedIn){
                       setAuthenticated(false)
                       setAuthBody({role: 'visitor'})
                       alert("You have been logged out due to inactivity. Please log in again.")
                     }
                     else{
                       alert(`Case ${oldData.case_id} patient data has been successfully updated.`)

                        window.location.reload()
                     }
                   })
                   ;
                 }


               }
               resolve()
             }, 1000);
           })
      }
      :
      null

      }
      localization={{
          pagination: {
              labelDisplayedRows: '{from}-{to} of {count}'
          },
          toolbar: {
              nRowsSelected: '{0} row(s) selected'
          },
          header: {
              actions: hasRole(profile, ['super_admin', 'write_admin']) ? 'Edit'
              :
              'Create'
          },
          body: {
              emptyDataSourceMessage: 'No records to display',
              filterRow: {
                  filterTooltip: 'Filter'
              },
              editTooltip: "Create",

          }
      }}
      options={{
        actionsColumnIndex: hasRole(profile, ['super_admin', 'write_admin']) ? 9 : 1,
        sorting: true,
        pageSize: 20,
        pageSizeOptions: [10, 20, 50, 100],
        filtering: true,
        showTitle: false,
        toolbar: true,
        exportButton: false,
        draggable: false,
        tableLayout: 'fixed',
        headerStyle: {
          fontSize: '13px',
          lineHeight: 1.15,
          fontWeight: 700,
          color: '#173247',
          backgroundColor: '#f1f6f8',
          padding: '10px 4px',
          whiteSpace: 'normal',
          overflowWrap: 'normal',
          wordBreak: 'normal'
        },
        rowStyle: {
          fontSize: '14px',
          fontWeight: 600,
          color: '#244154'
        },
        searchFieldStyle: {
          minWidth: '260px',
          fontSize: '17px',
          color: '#173247'
        }
      }}
      style={{
        width: '100%',
        maxWidth: '100%',
        fontSize: '14px',
        boxShadow: 'none',
        tableLayout: 'fixed'
      }}
      />
          </div>

    <Dialog open={state.dialogFlagOpen} onClose={handleClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">
        <span style={{ fontSize: '24px', fontWeight: 800, color: '#173247' }}>Reset flag?</span>
      </DialogTitle>
      <DialogContent>
        <DialogContentText style={{fontSize: '17px', lineHeight: 1.6, color: '#405d6d'}}>
        Flag will reset for Case: {state.rowData ? state.rowData.case_id : null}.
        { state.rowData ?
          state.rowData.case_status == 2 ?
          " Are you sure you want to reset the flag or RESCAN? If RESCAN, please click case and click RESCAN button."
          :
          " Are you sure you want to reset the flag?"

          :
          null
        }
        </DialogContentText>
      </DialogContent>
      <DialogActions
        disableSpacing
        classes={{
          root: tableClass.root,
          spacing: tableClass.spacing
        }}
      >
        <Button
          onClick={handleSubmit}
          variant="contained"
          style={{
            minWidth: 110,
            minHeight: 44,
            borderRadius: 9,
            background: '#087a68',
            color: '#ffffff',
            fontSize: '15px',
            fontWeight: 800,
            textTransform: 'none'
          }}
        >
          Yes, reset
        </Button>
        <Button
          onClick={handleClose}
          variant="outlined"
          style={{
            minWidth: 90,
            minHeight: 44,
            borderRadius: 9,
            borderColor: '#cfdde3',
            color: '#244154',
            fontSize: '15px',
            fontWeight: 800,
            textTransform: 'none'
          }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
    <Dialog open={state.dialogMessageOpen} onClose={handleClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">
        <span style={{ fontSize: '24px', fontWeight: 800, color: '#173247' }}>Unable to update</span>
      </DialogTitle>
      <DialogContent>
        <DialogContentText style={{fontSize: '17px', lineHeight: 1.6, color: '#405d6d'}}>
        {state.oldData ? state.oldData.case_id : null} will not change slot. {state.error ? state.error.replace("_", " ") : null}.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleSlotClose}
          variant="contained"
          style={{
            minWidth: 90,
            minHeight: 42,
            borderRadius: 9,
            background: '#08728c',
            color: '#ffffff',
            fontSize: '15px',
            fontWeight: 800,
            textTransform: 'none'
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
        </ThemeProvider>
      </div>
    </div>
  );
};

export default MRIqcList;